import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CustomButton from 'Components/CustomButton/CustomButton'
import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { currentDate } from 'utils/helpers'
import DocumentPng from 'Components/images/document.png'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CreateDocumentsForm({ setDocument, modelName = false, taskid = false }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const [types, setTypes] = useState([])
  const [file, setFile] = useState(null)

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Type: '',
      Nom: '',
      Description: '',
      Externe: '',
      Datedéchéance: currentDate(),
    },
  })

  const fetchDocumentsTypes = async () => {
    const url = urls.fetchDocumentsTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Type}`, id: v.id })
      })
      setTypes([...filterTypes])
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    fetchDocumentsTypes()
  }

  const handleClose = () => {
    setOpen(false)
    setFile(null)
    reset()
  }

  const onSubmit = async () => {
    const formData = new FormData()
    let check = false
    if (getValues('Type')) {
      formData.append('Type', getValues('Type')?.id)
    } else {
      setError('Type')
      check = true
    }
    if (file != null) {
      formData.append('Lien', file)
    } else {
      setError('file', { type: 'custom', message: 'Please add file.' })
      check = true
    }
    if (!getValues('Nom')) {
      check = true
      setError('Nom')
    }
    formData.append('Nom', getValues('Nom'))
    formData.append('Description', getValues('Description'))
    formData.append('Externe', getValues('Externe'))
    formData.append('Datedéchéance', getValues('Datedéchéance'))

    if (check) {
      return
    }
    // if (taskid) {
    //   setDocument(formData)
    // }
    setDocument(formData)
    handleClose()
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen} sx={{ color: 'black' }}>
        {modelName ? modelName : <img alt="" src={DocumentPng} />}
      </CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'Black !important' }}>{t('mesToDo.addDocument')}</DialogTitle>
        {/* <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data"> */}
        <Box>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Type', j)}
              label={t('mesToDo.fieldDocumentType')}
              data={types}
              name="Type"
              required={true}
              error={errors.Type}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Nom"
              label={t('mesToDo.fieldName')}
              error={errors.Nom}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Description"
              label={t('mesToDo.description')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: false,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: false }}
              name="Externe"
              label={t('mesToDo.fieldExternalNumber')}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Datedéchéance"
              label={t('mesToDo.fieldDueDate')}
            />
            <Button
              variant="contained"
              component="label"
              sx={{
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
              }}
            >
              <input
                name="file"
                type="file"
                filename={file}
                required={true}
                // accept="application/pdf"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>
            {errors.file && <p style={{ color: 'red' }}>{errors.file.message}</p>}
          </DialogContent>
          <DialogActions>
            <Button onClick={onSubmit}>{t('mesToDo.update')}</Button>
            <Button onClick={handleClose}>{t('mesToDo.cancel')}</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}
